<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		id="document-vat-table-dialog-header"
		[title]="'scenes.document.form.dialogs.vat-table.title' | translate"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		@if (viewModel.isFormReady) {
			<div class="align--form">
				<div class="document-vat-table-dialog-sub-title" id="document-vat-table-dialog-grid-currency-values-title">
					{{ 'scenes.document.form.dialogs.vat-table.grid-title' | translate }} {{ viewModel.currency.symbol }}
				</div>
				<skl-grid-ins
					id="document-vat-table-dialog-grid-currency-values"
					[dataSource]="viewModel.gridDataSource$"
					[columns]="viewModel.gridColumns$"
					[options]="viewModel.gridOptions">
				</skl-grid-ins>
				@if (viewModel.documentInForeignCurrency && !viewModel.hideBaseCurrencyVatTable) {
					<div>
						<div class="document-vat-table-dialog-sub-title align--huge-top" id="document-vat-table-dialog-grid-base-currency-values-title">
							{{ 'scenes.document.form.dialogs.vat-table.grid-title' | translate }} {{ viewModel.baseCurrency!.symbol }}
						</div>
						<skl-grid-ins
							id="document-vat-table-dialog-grid-base-currency-values"
							[dataSource]="viewModel.gridDataSourceBaseCurrency$"
							[columns]="viewModel.gridColumnsBaseCurrency$"
							[options]="viewModel.gridOptions">
						</skl-grid-ins>
					</div>
				}
			</div>
		}
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="document-vat-table-dialog-close-button"
			(click)="onCancel()">
			{{ 'scenes.document.form.dialogs.vat-table.button.close' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>